import { render, staticRenderFns } from "./PromoterConsultBanner.vue?vue&type=template&id=d85a792e&scoped=true"
import script from "./PromoterConsultBanner.vue?vue&type=script&lang=js"
export * from "./PromoterConsultBanner.vue?vue&type=script&lang=js"
import style0 from "./PromoterConsultBanner.vue?vue&type=style&index=0&id=d85a792e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85a792e",
  null
  
)

export default component.exports